// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progressbar_progressBarContainer__NN4s3 {
    height: 10px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    overflow: hidden;
}

.progressbar_progressBar__PEuYi {
    height: 40px;
    background-color: white;
    transition: width 0.016s linear;
    /* Smooth transition for the progress */
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/ProgressBar/progressbar.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,+BAA+B;IAC/B,uCAAuC;AAC3C","sourcesContent":[".progressBarContainer {\n    height: 10px;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.12);\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.progressBar {\n    height: 40px;\n    background-color: white;\n    transition: width 0.016s linear;\n    /* Smooth transition for the progress */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressBarContainer": `progressbar_progressBarContainer__NN4s3`,
	"progressBar": `progressbar_progressBar__PEuYi`
};
export default ___CSS_LOADER_EXPORT___;
